{
  "title": "Governance Overview",
  "description": "How agents are using tools, where policy steps in, and where people are the bottleneck.",
  "refresh": "Refresh",
  "fetchFailed": "Part of the overview could not be read. Refresh to try again.",
  "range": {
    "section": "Relative",
    "1h": "Last hour",
    "3h": "Last 3 hours",
    "24h": "Last 24 hours",
    "7d": "Last 7 days",
    "30d": "Last 30 days"
  },
  "rangeLabel": {
    "1h": "past hour",
    "3h": "past 3 hours",
    "24h": "past 24 hours",
    "7d": "past 7 days",
    "30d": "past 30 days"
  },
  "kpi": {
    "evaluated": "Evaluated requests",
    "evaluatedNote": "tool requests in the {{range}}",
    "pending": "Pending approvals",
    "pendingReview": "Review",
    "pendingOldest": "Oldest waiting {{age}} · workflows need a decision",
    "pendingNone": "Nothing is waiting on a person",
    "mttd": "Mean time to decide",
    "mttdNote": "from escalation to a human decision",
    "mttdNone": "no human decisions in the {{range}}",
    "automation": "Automation rate",
    "automationBy": "by policy rules",
    "automationAuto": "{{count}} auto",
    "automationEscalated": "{{count}} to a human"
  },
  "enforcement": {
    "title": "Enforcement outcomes",
    "note": "Tool requests by policy decision · {{range}} · click a series to isolate it",
    "allow": "Allowed",
    "approval_required": "Requires approval",
    "deny": "Denied",
    "empty": "No tool requests in this range."
  },
  "coverage": {
    "title": "Agent coverage",
    "note": "Active agents with a policy assigned",
    "governed": "governed",
    "governedCount": "Governed",
    "deactivated": "Deactivated",
    "ungoverned": "Ungoverned",
    "ungovernedHeading": "Active with no policy",
    "assign": "Assign",
    "allGoverned": "Every active agent has a policy.",
    "noAgents": "No agents are registered."
  },
  "servers": {
    "title": "Calls by server",
    "note": "{{tools}} tools on {{servers}} MCP servers · {{range}}",
    "days": "{{from}} – {{to}}, full days (UTC)",
    "day": "{{from}}, full day (UTC)",
    "open": "Candidate rules",
    "empty": "No tool calls in this range.",
    "more": "{{count}} more servers in Candidate Rules",
    "partial": "Counts cover the most called records only."
  },
  "tools": {
    "title": "Tool activity",
    "note": "Top 5 MCP tools · {{range}}",
    "mostUsed": "Most used",
    "mostBlocked": "Most blocked",
    "tools": "Tools",
    "agents": "Agents",
    "noneUsed": "No tool calls in this range.",
    "noneBlocked": "Nothing was denied in this range."
  },
  "approvals": {
    "title": "Human approvals",
    "note": "Escalated requests by reviewer decision",
    "escalated": "Escalated",
    "approved": "Approved",
    "denied": "Denied",
    "pending": "Pending",
    "waiting": "Waiting longest",
    "allPending": "All {{count}} pending →",
    "noneWaiting": "No workflows are waiting on a decision.",
    "empty": "Nothing was escalated in this range."
  },
  "policies": {
    "title": "Most-triggered policies",
    "note": "Evaluations by policy, with the rules that decided the most calls",
    "policy": "Policy",
    "rules": "Top rules",
    "evaluations": "Evaluations",
    "noRules": "decided by the default action",
    "empty": "No policy evaluated a tool call in this range."
  },
  "revisions": {
    "title": "Revision velocity",
    "note": "Policy revisions by origin · {{count}} total",
    "create": "Create",
    "edit": "Edit",
    "fork": "Fork",
    "revert": "Revert",
    "empty": "No policy revisions in this range."
  },
  "orphans": {
    "title": "Orphaned policies",
    "note": "Published, but no active agent is assigned",
    "count": "{{count}} orphaned",
    "created": "Created {{date}}",
    "agents": "0 agents",
    "assign": "Assign agents",
    "none": "Every policy has at least one active agent.",
    "partial": "Only the oldest {{limit}} are listed."
  },
  "locks": {
    "title": "Draft edit locks",
    "note": "Holds on policy drafts · a stale hold blocks other editors",
    "stale": "{{count}} past expiry",
    "holder": "{{name}} · locked {{since}}",
    "you": "You",
    "unknownHolder": "Another editor",
    "newPolicy": "New policy",
    "expiresIn": "Expires in {{age}}",
    "expired": "Expired {{age}} ago",
    "lapsed": "Expired",
    "release": "Release",
    "none": "No drafts are open."
  }
}
